// extracted by mini-css-extract-plugin
module.exports = {"portraitAccordion":"courseVideoFrame_portraitAccordion__l5r6f","portraitHero":"courseVideoFrame_portraitHero__KIjFe"};